import React, { useContext, useEffect, useMemo, useState } from 'react'
import { Link } from 'gatsby'
import * as classes from './CorporateGovernance.module.scss'
import cn from 'classnames'
import Container from '../../ui/Container/Container'
import BreadCrumbs from '../../ui/BreadCrumbs/BreadCrumbs'
import IconRight from '../../icons/IconRight'
import { useWindowSize } from '../../../hooks/useWindowSize'
import { getPhotoSize } from '../../../utils/getPhotoSize'
import { deleteHtmlTag } from '../../../utils/deleteHtmlTag'
import { FormContext } from '../../../context'
import splitRow from '../../../utils/splitRow'
import { gsap } from 'gsap/dist/gsap'
import { ScrollTrigger } from 'gsap/dist/ScrollTrigger'
import { startAnimationScroll } from '../../../utils/animations'
import splitTitleV2 from '../../../utils/splitTitleV2'
import Item from './Item'

gsap.registerPlugin(ScrollTrigger)

function CorporateGovernance({ crumbs, data, lang, textLocation, moreText, lessText }) {
    const { animationStart } = useContext(FormContext)

    const windowSize = useWindowSize()
    const imageSize = getPhotoSize(windowSize.width)

    const title = useMemo(() => deleteHtmlTag(data.title?.value, 'p'), [data.title])
    const text = useMemo(() => deleteHtmlTag(data.text?.value, 'p'), [data.text])
    const location = useMemo(() => deleteHtmlTag(textLocation, 'p'), [textLocation])

    const getItemLink = (href) => {
        if (lang === 'hy') {
            return href
        } else {
            return `/en${href}`
        }
    }

    const [titlePrint, setTitlePrint] = useState(title)

    let newArr = []

    if (data.items?.nodes?.length) {
        newArr = data.items.nodes.map((item) => {
            const itemFiles = data.files?.nodes?.filter((file) => file.section?.id === item.id) || []

            return {
                title: item.title,
                desc: deleteHtmlTag(item.description, 'p'),
                files: itemFiles,
                photo: {
                    1440: item?.image?.url || '',
                    768: item?.image?.url || '',
                    360: item?.image?.url || ''
                }
            }
        })
    }

    const classAnimationTitle = 'anime-title-governance-brief'
    const classAnimationText = 'anime-text-governance-brief'

    useEffect(() => {
        if (animationStart) {
            splitRow(classAnimationText)
            splitTitleV2(classAnimationTitle)
        }

        const observer = startAnimationScroll([
            { type: 'text', className: classAnimationText },
            { type: 'title', className: classAnimationTitle }
        ])

        return () => {
            if (observer) {
                observer.disconnect()
            }
        }
    }, [animationStart])

    useEffect(() => {
        const timer = setTimeout(() => {
            const elems = document.querySelectorAll('.governance-item-footer')

            elems.forEach((item, index) => {
                gsap.to(item, {
                    duration: 1.4,
                    opacity: 1,
                    ease: 'cubicBezier(0.25, 0.1, 0.25, 1)',
                    scrollTrigger: {
                        trigger: item,
                        start: 'top 80%'
                    }
                })
            })
        }, 1500)

        return () => clearTimeout(timer)
    }, [])

    return (
        <section className={cn(classes.Section, { [classes.LangHY]: lang === 'hy' })}>
            <Container>
                <BreadCrumbs list={crumbs} black />

                {titlePrint || text ? (
                    <div className={classes.Header}>
                        {titlePrint ? (
                            <h2 className={`${classes.Title} ${classAnimationTitle}`} dangerouslySetInnerHTML={{ __html: titlePrint }} />
                        ) : null}

                        {text ? <p className={`${classes.Desc} ${classAnimationText}`} dangerouslySetInnerHTML={{ __html: text }} /> : null}
                    </div>
                ) : null}
                {data.items.nodes.length ? (
                    <div className={classes.Items}>
                        {newArr.map((item, index) => (
                            <Item key={index} item={item} imageSize={imageSize} lang={lang} location={location} getItemLink={getItemLink} moreText={moreText} lessText={lessText} />
                        ))}
                    </div>
                ) : null}
            </Container>
        </section>
    )
}

export default CorporateGovernance
